// **********************************************************
// Wishlist button
// **********************************************************

const wishlistBtn = document.querySelectorAll('.wishlist-button');

wishlistBtn.forEach((wishlistButtonEle) => {
  wishlistButtonEle.addEventListener('click', (ev) => {
    ev.preventDefault();
    const axiosData = new FormData();
    axiosData.append('action', 'toggleItemOnLikedList');
    axiosData.append('productid', ev.target.closest('button').dataset.productid);
    axios
      .post(localData.siteURL, axiosData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        if (response.status === 200) {
          const wishlistBtnContent = wishlistButtonEle.querySelector('.wishlist-button__text');
          wishlistButtonEle.classList.toggle('is-active', response.data.data.liked);

          if (wishlistBtnContent) {
            if (ev.target.classList.contains('is-active')) {
              wishlistButtonEle.classList.add('is-open');

              setTimeout(() => {
                wishlistButtonEle.classList.remove('is-open');
              }, 800);
            }
          }
          updateWishListQuantityBadge();
        }
      })
  });
});

